import type { ChaliceStore } from '../types';

export const selectAuthenticated = (state: ChaliceStore) =>
  state.user.authenticated === true;
export const selectCareerFeedAiAssistantChatContextCookie = (
  state: ChaliceStore,
) => state.user.careerFeedAiAssistantChatContextCookie;
export const selectEnableZhForSSR = (state: ChaliceStore) =>
  state.user.enableZhForSSR;
export const selectEventCaptureTestTags = (state: ChaliceStore) =>
  state.user.testTags;
export const selectHasInitialSolIdCookie = (state: ChaliceStore) =>
  state.user.hasInitialSolIdCookie;
export const selectIsAuthenticationResolved = (state: ChaliceStore) =>
  state.user.authenticated !== undefined;
export const selectServerAuthenticated = (state: ChaliceStore) =>
  state.user.serverAuthenticated === true;
export const selectSessionId = (state: ChaliceStore) => state.user.sessionId;
export const selectSolId = (state: ChaliceStore) => state.user.solId;
export const selectStateToken = (state: ChaliceStore) =>
  state.search.stateToken;
export const selectTimezone = (state: ChaliceStore) => state.user.timezone;
export const selectUserAgent = (state: ChaliceStore) => state.user.userAgent;
export const selectUserClientId = (state: ChaliceStore) =>
  state.user.userClientId;
export const selectUserTestHeaders = (state: ChaliceStore) =>
  state.user.testHeaders;
